import type { Config } from "@/api/models"

export const FLOW_EMAIL_DISABLED_REASON =
  "Configure Flow email in Admin Dashboard before using this node."

export function isFlowEmailReady(settings: Pick<Config, "flowEmailReady">): boolean {
  return settings.flowEmailReady === true
}

export function getFlowEmailDisabledReason(
  settings: Pick<Config, "flowEmailReady">
): string | null {
  return isFlowEmailReady(settings) ? null : FLOW_EMAIL_DISABLED_REASON
}
